import type { AssociatedField, Field } from '../../../../types/layout-items.tsx';

export const hasDefaultValueProperty = (field: Field | AssociatedField): field is AssociatedField =>
	Object.prototype.hasOwnProperty.call(field, 'defaultValue');
